module.exports = __webpack_public_path__ + "img/code-html-xl.97663a9f.webp";